// App.js
import React, { useState, useEffect } from "react";
import { Routes, Route, useNavigate, Navigate } from "react-router-dom";

// Import the pages for each role
import AuthPage from "./pages/AuthPage";
import EmployeeDashboard from "./pages/employee-dashboard";
import ManagerDashboard from "./pages/manager-dashboard";
import ShopperDashboard from "./pages/customer-dashboard";

function App() {
  const getStoredRole = () => localStorage.getItem("role");
  const [userRole, setUserRole] = useState(getStoredRole);
  const navigate = useNavigate();

  useEffect(() => {
    const storedRole = getStoredRole();
    if (storedRole) {
      setUserRole(storedRole);
    }
  }, []);

  const resolvedRole = userRole || getStoredRole();

  const getDashboardPath = (role) => {
    switch (role) {
      case "manager":
        return "/manager-dashboard";
      case "employee":
        return "/employee-dashboard";
      case "shopper":
        return "/customer-dashboard";
      default:
        return "/customer-dashboard";
    }
  };

  const handleLogin = (role) => {
    setUserRole(role);
    localStorage.setItem("role", role);
    navigate(getDashboardPath(role));
  };

  const handleLogout = () => {
    setUserRole(null);
    ["token", "userId", "employeeId", "username", "email", "phone", "address", "role"].forEach((key) =>
      localStorage.removeItem(key),
    );
    navigate("/");
  };

  return (
    <Routes>
      <Route
        path="/"
        element={
          resolvedRole ? <Navigate to={getDashboardPath(resolvedRole)} replace /> : <AuthPage onLogin={handleLogin} />
        }
      />

      <Route
        path="/manager-dashboard"
        element={
          resolvedRole === "manager" ? (
            <ManagerDashboard onLogout={handleLogout} userId={localStorage.getItem("userId")} />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />

      <Route
        path="/employee-dashboard"
        element={
          resolvedRole === "employee" ? (
            <EmployeeDashboard onLogout={handleLogout} />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />

      <Route
        path="/customer-dashboard"
        element={
          resolvedRole && resolvedRole !== "manager" && resolvedRole !== "employee" ? (
            <ShopperDashboard onLogout={handleLogout} />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
    </Routes>
  );
}

export default App;
